import { Component } from '@angular/core';

import { CamTranslationCore } from '@camelot/core';
import { AbstractCellComponent } from '@camelot/core';
import { TranslatePipe } from '@camelot/translation';

import { BillingRow } from '../../../../../common/services/dto/row';
import { Unit } from '../../../../../common/services/dto/unit';

@Component({
  host: { 'data-cid': 'grid-billing-unit-cell' },
  imports: [TranslatePipe],
  selector: '',
  template: `{{ this.unitName | translate }}`,
})
export class GridBillingUnitCellComponent extends AbstractCellComponent<BillingRow, Unit> {
  constructor() {
    super();
    CamTranslationCore.getInstance();
  }

  get unitName() {
    if (!this.value) {
      return '';
    }
    if (this.value === Unit.Other) {
      return this._item?.unitDescription ?? '';
    }
    return `core.default-unit.${Unit[this.value]?.toLowerCase() ?? 'unknown'}`;
  }
}
